(function () {
  'use strict';

  angular
    .module('simUtilizationReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('simUtilizationReport', {
        url: '/sim-utilization-report',
        views: {
          'simUtilizationReportView': {
            templateUrl: 'sim-utilization-report/views/sim-utilization-report.tpl.html',
            controller: 'SimUtilizationReportCtrl',
            controllerAs: 'simUtilizationReport'
          }
        }
      });
  }
}());
